import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingCourse = ({ message = 'Eğitim yükleniyor...', showError = false }) => {
  return (
    <div className="min-h-screen bg-gray-900 text-white flex flex-col items-center justify-center px-4 text-center">
      <Loader2 className="h-12 w-12 text-purple-500 mb-6 animate-spin" />
      <p className={`text-lg sm:text-xl font-semibold ${showError ? 'text-red-400' : 'text-gray-100'}`}>
        {message}
      </p>
    </div>
  );
};

export default LoadingCourse;

